// eslint-disable-next-line
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import addToCart from "../../helpers/addToCart";
import UserContext from "../../context/context";
import { CiSearch } from "react-icons/ci";
const DisplayCategoryWiseProduct = ({ filterSearch }) => {
  const { fetchCartCount } = useContext(UserContext);
  const [isClicked, setIsClicked] = useState(false);

  const handleAddToCart = async (e, productId) => {
    setIsClicked(true);
    try {
      await addToCart(e, productId);
      fetchCartCount();
    } catch (error) {
      console.error("Error adding product to cart:", error);
    } finally {
      setIsClicked(false);
    }
  };

  return (
    <div className="container p-4 mx-auto relative">
      <div className="flex md:gap-5 gap-3 my-4 transition-all scroll-smooth items-center justify-center flex-wrap">
        {filterSearch?.length > 0 ? (
          filterSearch.map((product) => (
            <Link
              to={`/product/${product._id}`}
              key={product._id}
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
              className="w-[calc(50%-0.5rem)] md:w-[calc(33.333%-1.25rem)] max-w-[165px] md:max-w-[320px] shadow-md rounded-md overflow-hidden mb-4"
            >
              <div className="h-48 items-center min-w-[165px] md:min-w-[320px] max-w-[165px] md:max-w-[320px] p-4 bg-slate-200">
                <img
                  src={product?.product_image[0]}
                  alt={product?.name || "Product Image"}
                  className="w-full h-full object-scale-down mix-blend-multiply hover:scale-110 duration-300"
                  loading="lazy"
                />
              </div>

              <div className="w-full md:max-w-[320px] p-4  bg-white py-2 grid gap-2">
                <h2 className="font-semibold text-ellipsis line-clamp-1">
                  {product?.name}
                </h2>
                <p className="text-sm text-gray-500 capitalize my-1">
                  {product?.category}
                </p>
                <div className="flex gap-3 items-center my-2">
                  {product?.discount > 0 ? (
                    <div className="flex flex-row gap-3 items-center">
                      <p className="text-[#6fdedc] font-bold ">
                        ${product?.discount}
                      </p>
                      <p className="text-gray-500  line-through">
                        ${product?.price}
                      </p>
                    </div>
                  ) : (
                    <p className="text-[#6fdedc] font-bold">
                      ${product?.price}
                    </p>
                  )}
                </div>
                {product?.quantity > 0 ? (
                  <button
                    disabled={isClicked}
                    className="bg-slate-100 w-full h-10 rounded flex items-center justify-center  hover:bg-main-background py-1 px-3 transition-all hover:animate-pulse hover:text-white hover:font-bold"
                    // className="w-full bg-main-background text-white text-sm font-semibold py-1 px-3 rounded-full"
                    onClick={(e) => handleAddToCart(e, product._id)}
                  >
                    {" "}
                    <span className="text-lg flex items-center mx-auto justify-between gap-2">
                      <p className="text-base text-slate-400 font-bold hover:text-white px-1 transition-all duration-300">
                        Add To Cart
                      </p>
                      {/* <FiShoppingBag /> */}
                    </span>{" "}
                  </button>
                ) : (
                  <button
                    disabled
                    className="w-full text-white text-sm mt-1 font-semibold px-3 py-1 rounded-full bg-red-500"
                  >
                    Out of Stock
                  </button>
                )}
              </div>
            </Link>
          ))
        ) : (
          <div className=" flex flex-col gap-10 justify-center items-center text-center">
            <span className="text-[200px] text-slate-300 animate-pulse transition-all duration-1000 ease-in-out">
              <CiSearch />
            </span>
            <h2 className="text-2xl font-bold">No Products Found</h2>
            <p className="text-xl font-semibold text-slate-400">
              {" "}
              Try another search{" "}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DisplayCategoryWiseProduct;
